export enum AssignmentPhaseEnum {
  PREPARATION = 'preparation',
  ORDERING = 'ordering',
  PRODUCTION = 'production',
  CLOSING = 'closing',
  COMPLETED = 'completed',
  ARCHIVE = 'archive',
}
